export function TreeBottomSpace() {
	/** Render */
	return <div className="bottom-space flex-shrink-0" />;
}
